var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from "@glimmer/tracking";
import { CnamApiDmpConnectJSNotAvailable } from "cnam/utils/cnam-api-errors";
import CnamServicesAccessFormAuthenticationSetPinCodeAndComputerSettingsComponent from "cnam/components/cnam-services-access-form/authentication/set-pin-code-and-computer-settings";
import { getItemFromLocalStorage, setItemInLocalStorage } from "core/utils/use-local-storage";
import { State } from "../abstract/cnam-context";
import { AuthenticationContext } from "../authentication-context";
let DmpConnectJSAuthenticationContextAdapter = (_class = class DmpConnectJSAuthenticationContextAdapter extends AuthenticationContext {
  constructor(cnamAdapterName, pinCodeManager, cardReaderAdapter, dmpConnect, medic, store, fetcher, requestManager) {
    super(cnamAdapterName, cardReaderAdapter, medic, store, fetcher, requestManager);
    _initializerDefineProperty(this, "computerLocation", _descriptor, this);
    _initializerDefineProperty(this, "dmpConnectJSIsAvailable", _descriptor2, this);
    _initializerDefineProperty(this, "sessionOpened", _descriptor3, this);
    this.pinCodeManager = pinCodeManager;
    this.cardReaderAdapter = cardReaderAdapter;
    this.dmpConnect = dmpConnect;
    this.medic = medic;
    this.reset();
    this.states = [new State("check-installation-dmpconnect-js", () => {
      return Promise.resolve(!this.dmpConnectJSIsAvailable);
    }, async () => {
      try {
        await this.dmpConnect.registerConfiguration();
        this.dmpConnectJSIsAvailable = true;
      } catch {
        this.dmpConnectJSIsAvailable = false;
        throw new CnamApiDmpConnectJSNotAvailable();
      }
    }), new State("open-session", () => {
      return Promise.resolve(!this.sessionOpened);
    }, async () => {
      await this.dmpConnect.openSession();
      this.sessionOpened = true;
    }), new State("set-pin-code-and-computer-settings", () => {
      return Promise.resolve((!this.pinCodeManager.isStoredPinCodeValid || !this.computerLocation) && !this.dmpConnect.isRemoteMode);
    }, async () => {
      this.pinCodeManager.cachePinCode(this.pinCodeManager.typedPinCode);
      setItemInLocalStorage(this._computerLocationKey(), this.computerLocation);
    }, CnamServicesAccessFormAuthenticationSetPinCodeAndComputerSettingsComponent), new State("read-cps", () => {
      return Promise.resolve(!this.cpsInformations) || !(Boolean(this.computerLocation) && Boolean(this.availableLocations));
    }, async () => {
      this.cpsInformations = await this.cardReaderAdapter.getCpsInformations();
      this.availableLocations = this.cpsInformations.practiceLocations.filter(p => p.structureName && p.structureId);
      setItemInLocalStorage(this._availableLocationsKey(), JSON.stringify(this.availableLocations));
    }), ...this.states];
    this.currentState = this.states.find(state => state.key == "check-installation-dmpconnect-js");
  }
  reset() {
    super.reset();
    this.dmpConnectJSIsAvailable = false;
    this.sessionOpened = false;
    const computerLocationFromLocalStorage = getItemFromLocalStorage(this._computerLocationKey());
    this.computerLocation = computerLocationFromLocalStorage == null ? undefined : computerLocationFromLocalStorage;
    this.currentState = this.states.find(state => state.key == "check-installation-dmpconnect-js");
  }
  get isAuthenticated() {
    return !this.updatePracticeLocation && this.cpsInformations != undefined && (this.pinCodeManager.isStoredPinCodeValid || this.dmpConnect.isRemoteMode) && (this.cpsPracticeLocationIndice != undefined && this.cpsPracticeLocationIndice >= 0 && Boolean(this.practiceLocation) && (Boolean(this.computerLocation) || this.dmpConnect.isRemoteMode) && Boolean(this.availableLocations) && this.ratesChecked || Boolean(this.forcedIdentifier));
  }
  _computerLocationKey() {
    return "authentication:computer-location";
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "computerLocation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dmpConnectJSIsAvailable", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sessionOpened", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { DmpConnectJSAuthenticationContextAdapter as default };